const ProductPageInfo = {
  klaviyoStars: null,
  buybox: null,

  initiliaseElement() {
    this.klaviyoStars = document.querySelector('.klaviyo-star-rating-widget');
    this.buybox = document.querySelector('.js-buybox');
  },

  initializeEvents() {
    this.initiliaseElement();

    if (this.klaviyoStars != null) {
      const observer = new MutationObserver(() => {
        document
          .querySelectorAll('.kl_reviews__stars_badge')
          .forEach((badge) => {
            if (!badge.dataset.leavesReplaced && badge.querySelector('svg')) {
              badge.dataset.leavesReplaced = 'true';
              this.replaceStarsWithLeaves(badge);
            }
          });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (this.buybox != null) {
      const accordionItems = this.buybox.querySelectorAll(
        '.js-buybox__accordionItem',
      );

      accordionItems?.forEach((item) => {
        const button = item.querySelector('.js-buybox__accordionBtn');
        const content = item.querySelector('.js-buybox__accordionText');

        function updateFocusableState(container, isOpen) {
          const focusables = container.querySelectorAll(
            'a, button, input, textarea, select, [tabindex]',
          );
          focusables.forEach((el) => {
            if (isOpen) {
              el.removeAttribute('tabindex');
            } else {
              el.setAttribute('tabindex', '-1');
            }
          });
        }

        if (!item.classList.contains('is-open')) {
          updateFocusableState(content, false);
        }

        button.addEventListener('click', function () {
          const isOpen = item.classList.contains('is-open');

          accordionItems.forEach((accordion) => {
            accordion.classList.remove('is-open');
            updateFocusableState(
              accordion.querySelector('.js-buybox__accordionText'),
              false,
            );
          });

          if (!isOpen) {
            item.classList.add('is-open');
            updateFocusableState(content, true);
          }
        });
      });
    }
  },

  replaceStarsWithLeaves(container) {
    container.querySelectorAll('svg.kl_reviews__full_star').forEach((star) => {
      star.outerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M12.1937 0.976012C12.1937 0.976012 10.9164 1.58461 7.48345 1.79215C3.04144 2.0614 0.830582 4.6767 0.832032 8.23154V13.1242C0.832032 13.1242 4.71734 13.1228 6.01051 13.1214C9.6856 13.12 12.5257 10.234 12.6619 6.68199C12.7823 3.56327 12.1922 0.974609 12.1922 0.974609L12.1937 0.976012Z" fill="#004A54"/>
    </svg>`;
    });

    container
      .querySelectorAll('svg.kl_reviews__empty_star')
      .forEach((emptyStar) => {
        emptyStar.style.display = 'none';
      });
  },
};

export default ProductPageInfo;
